import React, { Component } from 'react';

import config from '../../config';
import { Field } from '../form';

import map from 'lodash/map';
import get from 'lodash/get';
import sample from 'lodash/sample';
import shuffle from 'lodash/shuffle';
import isEmpty from 'lodash/isEmpty';


import classNames from 'classnames';
import { Button, Collapse } from 'reactstrap';

import CustomSlugInputField from '../Links/CustomSlugInputField';
import PixelSetsSelectAdapter from '../PixelSets/PixelSetsSelectAdapter';

// Icons
import {FontAwesomeIcon as FA} from '@fortawesome/react-fontawesome';

import faChevronRight from '@fortawesome/fontawesome-pro-light/faChevronRight';
import faChevronDown from '@fortawesome/fontawesome-pro-light/faChevronDown';
import faLongArrowUp from '@fortawesome/fontawesome-pro-light/faLongArrowUp';
import faCog from '@fortawesome/fontawesome-pro-light/faCog';
import faDice from '@fortawesome/fontawesome-pro-light/faMagic';

import ReactFilestack from 'filestack-react';

import preventDefault from '../../utils/preventDefault';
// import getContrastYIQ from '../../utils/getContrastYIQ';

import ColorPicker from '../helpers/ColorPicker';
import GradientPicker from '../helpers/GradientPicker';




import MAGIC_COLORS from './magicColors';



const getMagicTheme = () => {
  const group = shuffle(sample(MAGIC_COLORS));
  return {backgroundAngle: 225, backgroundGradient: true, background: [group[0], group[1]], buttonsColor: group[2]};
}

class Accordion extends Component {
  
  constructor (props){
    super(props);
    
    this.setActiveTab = this.setActiveTab.bind(this)
    
    this.state = {
      activeTab: this.props.defaultKey
    }
  }
  
  setActiveTab (tab){
    return (e) => { preventDefault(e); this.setState({activeTab: (this.state.activeTab === tab ? this.props.defaultKey : tab)}) };
  }
  
  render (){
    const { render } = this.props;
    const { activeTab } = this.state;
    return render({setActiveTab: this.setActiveTab, activeTab});
  }
}

const AccordionTab = ({children, name, tabKey, setActiveTab, activeTab, forceOpen}) => {
  const isOpen = (forceOpen || activeTab === tabKey);
  return (<div className={classNames({[`collapse-${tabKey}`]: true, "accordion-tab": true, "action-sheet-wrap": true, opened: isOpen})}>
    <div onClick={forceOpen ? null : setActiveTab && setActiveTab(tabKey)} className="collapse-toggle">{name}<FA icon={(isOpen ? faChevronDown : faChevronRight)} /></div>
    <Collapse className={classNames({"action-sheet-wrap": true, "tab-content": true, "opened": isOpen})} isOpen={isOpen}>
      {children}
    </Collapse>
  </div>)
}


const backgroundFilestackOptions = {
  accept: ["image/*"],
  maxSize: 1024 * 1024 * 5, // 3 Mb max file size
  transformations: {
    crop: true,
    circle: false,
    rotate: true
  },
  imageMax: [2480, 2480]
}


const THEMES = [
  // 'christmas2020-1',
  // 'christmas2020-2',
  // 'christmas2020-3',
  // 'christmas2020-4',
  // 'christmas2020-5',
  // 'christmas2020-6',
  // 'christmas2020-7',
  // 'christmas2020-8',
  // 'valintine2020-1',
  // 'valintine2020-2',
  // 'valintine2020-3',
  // 'valintine2020-4',
  // 'valintine2020-5',
  // 'valintine2020-6',
  // 'valintine2020-7',
  // 'valintine2020-8',
  // 'valintine2020-9',
  'invert',1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29
];


class SettingsComponent extends Component {
  constructor (props){
    super(props);
    
    const { values } = this.props;
    
    this.state = {
      slugForceOpen: !((values.slug && values.slug !== values.unique_slug) || values.custom_slug)
    }
  }
  
  render() {
    const { submitting, values, form } = this.props;
    const settings = (values || {}).settings || {};
    const backgroundGradient = (settings.style || {}).backgroundGradient
    
    return (
      <div>
        <Accordion defaultKey={'slug'} render={(props) => (<React.Fragment>
          
          <AccordionTab tabKey="theme" name="Theme" {...props}>
            
            <Field
              name="settings.theme"
              render={({input}) => (<React.Fragment>
                {map(THEMES, (theme) => <span className={classNames({"theme-btn": true, [`theme-${theme}`]: true, 'selected': input.value === `${theme}`})} key={theme} onClick={()=> input.onChange(`${theme}`)} />)}
                <span title="I`m feeling lucky" className={classNames({'theme-btn': true, 'theme-lucky': true})} onClick={()=> {input.onChange("custom"); form.change('settings.style', getMagicTheme());}}>
                  <FA icon={faDice} />
                </span>
                <span title="Custom" className={classNames({'theme-btn': true, 'theme-custom-btn': true, 'selected': input.value === 'custom'})} onClick={()=> {input.onChange("custom"); setTimeout(props.setActiveTab('style'), 350);}}>
                  <FA icon={faCog} />
                </span>
              </React.Fragment>)}
            />
            
          </AccordionTab>
          
          <Collapse isOpen={settings.theme === 'custom'}>
            <AccordionTab tabKey="style" name="Buttons Color" {...props}>
              <div className="action-sheet-wrap nopadding">
                <Field
                  name="settings.style.buttonsColor"
                  render={({input}) => <ColorPicker {...input} />}
                />
              </div>
            </AccordionTab>

            <AccordionTab tabKey="style" name="Background" {...props}>
              
              { backgroundGradient === true && <Field
                name="settings.style.backgroundAngle"
                type="number"
                render={({input}) => (
                  <span className="background-angle-control" onClick={() => input.onChange( parseInt(input.value || 180, 10) % 360 + 45)}><FA icon={faLongArrowUp} style={{transform: `rotate(${input.value || 180}deg)`}} /></span>
                )}
              />}
              
              <div className="action-sheet-wrap nopadding">
                { backgroundGradient === true ?
                  <Field
                    name="settings.style.background"
                    render={({input}) => <GradientPicker {...input} />}
                  />
                  :
                  <Field
                    name="settings.style.background"
                    render={({input}) => <ColorPicker {...input} />}
                  />
                }
              </div>
              
              <div className="text-center"><Field
                name="settings.style.backgroundGradient"
                render={({input}) => <Button color="link" onClick={() => input.onChange(!input.value)}>Tap here for {input.value === true ? 'solid color' : 'color gradient'}</Button>}
              /></div>
              
              <div className="text-center">
                <span>- or -</span>
                
                <Field name="settings.style.backgroundImage">
                  {({ input }) => (
                    <ReactFilestack
                      apikey={config.filestackKey}
                      actionOptions={backgroundFilestackOptions}
                      onSuccess={(res) => 
                        input.onChange(get(res, 'filesUploaded[0].url', null))
                      }
                      customRender={({ onPick }) => (
                        isEmpty(input.value) ? 
                          <div className="background-image-btn" onClick={onPick}><span>Upload Background Image</span></div>
                        : (
                          <div className="background-image-btn" onClick={() => input.onChange(null)}>
                            <style dangerouslySetInnerHTML={{__html: [`.background-image-btn::after{ background-image: url('${input.value}') !important; }`]}}></style>
                            <span>Remove Background Image</span>
                          </div>
                        )
                      )}
                    />
                  )}
                </Field>
                
              </div>
              
            </AccordionTab>
          </Collapse>
          
          <AccordionTab tabKey="slug" name="Bio Link alias" {...props}>
            <CustomSlugInputField submitting={submitting} values={values} />
          </AccordionTab>
            
          <AccordionTab tabKey="trackingPixels" name="Ad tracking Pixels" {...props}>
            Pixel lists: <Field 
              name="pixel_set_ids"
              showEmptyMsg={true}
              component={PixelSetsSelectAdapter}
            />
          </AccordionTab>
          
        </React.Fragment>)}/>
      </div>
    )
  }
}

const SettingsButton = (props) => {
  return (<span className="settings-button service-button" onClick={
      (e) => {
        preventDefault(e);
        props.setActionSheet({ActionComponent: SettingsComponent, title: "Settings & Style", props: props});
      }
    }>Settings</span>)
}


export default SettingsButton;


// WEBPACK FOOTER //
// ./src/components/SmartPages/SettingsButton.js